import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

const url = `${AWS_API_URL}/home/sensors`;

export async function getSensorsAPI() {
  return getRequest(url, await authorize());
}
